// deps
import React, { memo } from "react";

// internal-deps
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { isEmpty } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styles
import { ComponentWrapper } from "./styles";

// constants
import { RUSH_HOUR_TEXT_BANNER } from "@dineout-payment-success-ui/constants/Constants";
import { ICommsTextBanner } from "@dineout-payment-success-ui/interfaces/TableReservation";

const CommsTextBanner = (props: ICommsTextBanner) => {
    const { card } = props || {};

    if (!card && isEmpty(card)) {
        return null;
    }
    const widgetInfo = card?.card;
    const { parentStyle, text, borderColour, bgColour, color, iconUrl } = widgetInfo || {};
    const IMAGE_DIMENSION = "20"; //20 is the default value

    return (
        <ComponentWrapper
            parentStyle={parentStyle}
            style={{ backgroundColor: bgColour, border: `1px solid ${borderColour}`, color }}
        >
            <Text
                style={{ color: text.titleColor }}
                variant={"V2.body2.neutral.regular"}
                dangerouslySetInnerHTML={{ __html: text.title || "" }}
            />

            <Image
                cloudinaryId={iconUrl || RUSH_HOUR_TEXT_BANNER}
                alt=""
                width={IMAGE_DIMENSION}
                height={IMAGE_DIMENSION}
            />
        </ComponentWrapper>
    );
};

export default memo(CommsTextBanner);
